import { render, staticRenderFns } from "./kiosk-re-layout.vue?vue&type=template&id=2b02e22c&"
import script from "./kiosk-re-layout.vue?vue&type=script&lang=js&"
export * from "./kiosk-re-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports